<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="新增定期宝币种"
      width="800px"
      @close="closeDialog"
    >
      <el-form :model="val" ref="form" :rules="rules" label-width="150px">
        <el-form-item label="币种选择" prop="coinType">
          <el-select v-model="val.coinType">
            <el-option
              v-for="item in coinTypeList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单次最小存入金额：" prop="minAmount">
          <el-input-number
            v-model="val.minAmount"
            :min="0.0001"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="精度：" prop="scale">
          <el-input-number v-model="val.scale" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="定期时长：" prop="day">
          <el-input-number v-model="val.day" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item label="利率：" prop="annualrate">
          <el-input-number
            v-model="val.annualrate"
            :min="0"
            :max="1"
            :step="0.01"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="利率规则：" prop="rateText">
          <el-input type="textarea" v-model="val.rateText"></el-input>
        </el-form-item>
        <el-form-item label="违约费率：" prop="defaultRate">
          <el-input-number
            v-model="val.defaultRate"
            :min="0"
            :max="1"
            :step="0.01"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="违约规则：" prop="defaultRateText">
          <el-input type="textarea" v-model="val.defaultRateText"></el-input>
        </el-form-item>
        <el-form-item label="收益说明：" prop="interestText">
          <el-input type="textarea" v-model="val.interestText"></el-input>
        </el-form-item>
        <el-form-item label="利率说明图片：" prop="rateImg">
          <upload v-model="val.rateImg"></upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Upload from 'components/upload';

export default {
  name: 'pledgeCornucopia',
  data() {
    return {
      dialogVisible: false,
      val: {},
      rules: {
        coinType: {
          required: true,
          message: '请填写'
        },
        minAmount: {
          required: true,
          message: '请填写'
        },
        scale: {
          required: true,
          message: '请填写'
        },
        day: {
          required: true,
          message: '请填写'
        },
        annualrate: {
          required: true,
          message: '请填写'
        },
        defaultRate: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  components: {
    Upload
  },
  computed: {
    ...mapState('pledgeCornucopia', ['coinTypeList'])
  },
  methods: {
    ...mapActions('pledgeCornucopia', ['create']),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.create({ ...this.val }).then(() => {
        this.$message({
          message: '添加成功！',
          type: 'success'
        });
        this.dialogVisible = false;
        this.$emit('refresh');
      });
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
